const Style = {
    container: 'flex h-full w-full flex-col',
    main: 'flex flex-col gap-4 p-5',
    header: 'flex items-center justify-between border-b border-border px-4 py-3',
    emails: 'flex max-w-sm flex-col gap-2',
    subTitle: 'text-base font-semibold text-text-primary',
    hint: 'text-sm text-text-secondary',
};

export default Style;
